import { identityAccountId, IdentityAccountId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class IAMAccountCredentialsUpdateCmd {
  private static validation = JsonSchemaValidator.compile(
    IAMAccountCredentialsUpdateCmd.validationSchema()
  );

  constructor(readonly value: IAMAccountCredentialsUpdateCmdRaw) {
    JsonSchemaValidator.assert(
      IAMAccountCredentialsUpdateCmd.validation,
      value
    );
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId"],
      properties: {
        accountId: identityAccountId
      },
      additionalProperties: false
    };
  }
}

interface IAMAccountCredentialsUpdateCmdRaw {
  accountId: IdentityAccountId;
}
